// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__g5s6U","content":"style_content__evAel","content__nav":"style_content__nav__mnCf3","contentNav":"style_content__nav__mnCf3"};